export interface Group {
  id: number;
  team: number;
  memberIds: number[];
  groupName: string;
  autoAssign: boolean;
  isTeamAdminGroup: boolean;
}

export interface GroupAddRequest {
  groupName: string;
  memberIds: number[];
  autoAssign: boolean;
  team: number;
}

export enum BuiltInGroup {
  CRO = "CRO",
  TEAM_ADMIN = "TEAM_ADMIN",
  EXTERNAL = "EXTERNAL",
  USER = "USER",
  PROJECT_CREATOR = "PROJECT_CREATOR",
}

export interface GroupEditRequest extends Group {}
